import React, { useState } from 'react';
import BodyContainer from '../ui/BodyContainer';
import Verified from '../ui/signupSkeleton/Verified';
import AskMobNum from '../ui/signupSkeleton/AskMobNum';

import Services from '../services/services';
import toast, { Toaster } from 'react-hot-toast';

import makeStyles from '@material-ui/core/styles/makeStyles';
import accountVerifiedStyles from '../styles/accountVerified';

const useStyles = makeStyles((theme) => accountVerifiedStyles(theme));

function AccountVerified() {
  const classes = useStyles();
  const title = 'Account Verified';

  const sendOTPFunc = async (phoneNum) => {
    // if (!mobileOtpValidationFunc()) return null;
    try {
      const res = await Services.send_otp_login(phoneNum);
      if (res.data?.responseCode === 200) {
        toast.success(res.data.message, { duration: 5000 });
      } else {
        toast.error(res.data.details, { duration: 5000 });
      }
    } catch (error) {
      toast.error('Unknown Error!');
    }
  };

  return (
    <BodyContainer title={title}>
      <Verified />
      <AskMobNum sendOTPFunc={sendOTPFunc} inputStyles={classes.inputStyles} />
      <Toaster position='top-center'></Toaster>
    </BodyContainer>
  );
}

export default AccountVerified;
